import { useWatch, FieldValues } from 'react-hook-form';
import { useDelegateAdHocFormFreeTextInputOptions } from '../../../../../../../../hooks/confirmPurchase/delegate/useDelegateAdHocFormFreeTextInputOptions';
import { PricingFormInputOption } from '../../../../../../../../types';
import { PricingFormInputLayout } from '../../../../../../../../types/enums';
import Radio from '../../../../../../../../shared/library/Radio';
import RadioGroupField, {
  RadioGroupFieldProps,
} from '../../../../../../../../shared/formElements/RadioGroupField';
import AdHocFreeTextField from '../AdHocFreeTextField';

export interface AdHocRadioGroupFieldProps<TFieldValues>
  extends RadioGroupFieldProps<TFieldValues> {
  layout?: keyof typeof PricingFormInputLayout;
  options: PricingFormInputOption[];
}

export default function AdHocRadioGroupField<TFieldValues extends FieldValues>(
  props: AdHocRadioGroupFieldProps<TFieldValues>,
) {
  const { name, layout, options, ...radioFieldProps } = props;

  const { freeTextOption, filteredOptions: radioOptions } =
    useDelegateAdHocFormFreeTextInputOptions(options);
  const radioFreeTextOptionValue = '__checked__';
  const radioFreeTextOptionLabel = freeTextOption?.label;

  const selectedFreeTextValue = useWatch({
    name,
    disabled: !freeTextOption,
  }) as string;

  const showFreeTextField =
    !!freeTextOption && selectedFreeTextValue === radioFreeTextOptionValue;

  return (
    <>
      <RadioGroupField
        name={name}
        row={layout === PricingFormInputLayout.COLUMN}
        {...radioFieldProps}
      >
        {radioOptions.map((option) => (
          <Radio
            key={`${name}.${option.value}`}
            value={option.value}
            label={option.label}
          />
        ))}
        {!!freeTextOption && (
          <Radio
            value={radioFreeTextOptionValue}
            label={radioFreeTextOptionLabel}
          />
        )}
      </RadioGroupField>
      {showFreeTextField && <AdHocFreeTextField name={name} />}
    </>
  );
}
